import { ReactNode, useEffect } from "react";

export interface MapRendererProps<T> {
  data?: any;
  render: (item: any) => ReactNode;
  fallback?: ReactNode;
  fallbackTitle?: string;
}

export const MapRenderer = <T = {},>({
  data,
  render,
  fallback,
  fallbackTitle,
}: MapRendererProps<T>) => {
  if (!data || data.length < 1) {
    if (fallback) return fallback;

    return (
      <div className="flex items-center justify-center min-h-72 h-full w-full">
        <p>{fallbackTitle ?? "데이터가 없습니다."}</p>
      </div>
    );
  }

  return (data as T[])?.map((item: T) => render(item));
};
